import { createValidity, assertString } from '@mhub/web-validations';

export const PASSWORD_MIN_LENGTH = 12;

// The policy, one rule per entry. `label` is a natural-language translation
// key (locales/*/translation.json) rendered by AppForm.PasswordInput.
export const PASSWORD_RULES = [
  { key: 'minLength', label: 'At least {{count}} characters', test: v => v.length >= PASSWORD_MIN_LENGTH },
  { key: 'uppercase', label: 'One uppercase letter', test: v => /[A-Z]/.test(v) },
  { key: 'lowercase', label: 'One lowercase letter', test: v => /[a-z]/.test(v) },
  { key: 'number', label: 'One number', test: v => /\d/.test(v) },
  // a symbol is anything that is not alphanumeric or whitespace
  { key: 'symbol', label: 'One symbol', test: v => /[^A-Za-z0-9\s]/.test(v) },
];

export const PASSWORD_MATCH_LABEL = 'Passwords match';

// Per-rule pass/fail for a checklist. An empty value satisfies nothing.
export function passwordRuleStatus(value) {
  const v = value === undefined || value === null ? '' : String(value);
  return PASSWORD_RULES.map(rule => ({
    key: rule.key,
    label: rule.label,
    satisfied: v.length > 0 && rule.test(v),
  }));
}

export function isValidPassword(value) {
  return passwordRuleStatus(value).every(rule => rule.satisfied);
}

// Fails when the value breaks the policy. The message is empty on purpose:
// the field's checklist already shows which rule is unmet.
export default function password(value, opts) {
  assertString(value);
  const options = Object.assign({}, opts);
  const validity = createValidity(options.key || 'key');
  if (value !== '' && !isValidPassword(value)) {
    validity.isValid = false;
    validity.message = options.message || '';
  }
  return validity;
}



// WEBPACK FOOTER //
// ./src/utils/validations/password.js